// extracted by mini-css-extract-plugin
export default {"quizCard":"styles_quizCard__paEsg","quizAnswers":"styles_quizAnswers__KagYD","button":"styles_button__AKZ+W"};